'use client'

import type { ReactNode } from 'react'

export const ScorecardV2Verdict = ({ description }: { description: ReactNode }) => (
  <p className="glossary-on-dark text-[16px] leading-relaxed font-normal text-white/90">{description}</p>
)
